'use client';

import Icon from '@/Icon';
import { clc, type BaseProps } from '@/legacy/components/base/utils';
import styles from '@/legacy/components/modalContents/AppDownModal.module.scss';
import appLink from '@/legacy/constants/link.json';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type React from 'react';
import { useTransTournament } from '@/@shared/hooks/useTranslations';

type Props = {
	titleComp: React.ReactNode;
	QRTopDescription?: boolean;
	QRBottomDescription?: boolean;
	closeFn?: BaseProps['button']['onClick'];
	className?: string;
};

const AppDownModal = ({
	titleComp,
	QRTopDescription = false,
	QRBottomDescription = false,
	closeFn,
	className,
}: Props) => {
	// const locale = useLocaleLink()
	const t = useTransTournament('temp.home');
	return (
		<div className={clc(styles.wrap, className)}>
			<div className={styles.top}>
				{titleComp}
				<button className={styles.closeButton} onClick={closeFn}>
					<Icon className={styles.close} color1={'#1A1A20'} path="Navi_Close_48_Black" />
				</button>
			</div>

			<hr className={styles.hr} />
			{QRTopDescription && <span className={styles.last}>{t('scanQRCode')}</span>}
			<Icon className={styles.qr} path="QRCode" />
			{QRBottomDescription && (
				<div className={styles.ds}>
					<span className={styles.description} dangerouslySetInnerHTML={{ __html: t('downloadChallenge') }} />
				</div>
			)}

			<hr className={styles.hr} />
			<span className={styles.last}>{t('appStoreDownload')}</span>
			<div className={styles.buttons}>
				<Link className={styles.button} href={appLink['app']} target="_blank">
					<Icon className={styles.btIcon} path="apple_store_logo" />
				</Link>
				<Link className={styles.button} href={appLink['play']} target="_blank">
					<Icon className={styles.btIcon} path="google_play_logo" />
				</Link>
			</div>
		</div>
	);
};

export default AppDownModal;
